// Two route trees, two shells, two products. `/admin/*` mounts the
// Mission Control cockpit, everything else mounts the Studio, and the two
// are deliberately not variations of one layout: see
// components/shell/AdminShell.tsx and components/shell/UserShell.tsx.
//
// The URL is still the single source of truth for which one you are in --
// `/admin` is the cockpit, and signing in does not depend on which shell
// you started from (guards/redirects are unchanged from Phase 10).
import { Route, Routes } from "react-router-dom";
import { RequireAuth } from "./components/Guards";
import AdminShell from "./components/shell/AdminShell";
import UserShell from "./components/shell/UserShell";
import Login from "./views/Login";
import Generate from "./views/Generate";
import Tasks from "./views/Tasks";
import TaskDetail from "./views/TaskDetail";
import Library from "./views/Library";
import Compare from "./views/Compare";
import Cut from "./views/Cut";
import PromptIdeas from "./views/PromptIdeas";
import Account from "./views/Account";
import AdminOverview from "./views/admin/AdminOverview";
import AdminTasks from "./views/admin/AdminTasks";
import AdminTaskDetail from "./views/admin/AdminTaskDetail";
import AdminCompute from "./views/admin/AdminCompute";
import AdminPolicy from "./views/admin/AdminPolicy";
import AdminUsers from "./views/admin/AdminUsers";
import AdminAliases from "./views/admin/AdminAliases";
import AdminKillSwitch from "./views/admin/AdminKillSwitch";
import AdminCatalog from "./views/admin/AdminCatalog";

export default function App() {
  return (
    <Routes>
      <Route element={<UserShell />}>
        <Route path="/login" element={<Login />} />
        <Route path="/" element={<RequireAuth><Generate /></RequireAuth>} />
        <Route path="/tasks" element={<RequireAuth><Tasks /></RequireAuth>} />
        <Route path="/tasks/:id" element={<RequireAuth><TaskDetail /></RequireAuth>} />
        <Route path="/library" element={<RequireAuth><Library /></RequireAuth>} />
        <Route path="/library/compare" element={<RequireAuth><Compare /></RequireAuth>} />
        <Route path="/library/cut/:id" element={<RequireAuth><Cut /></RequireAuth>} />
        <Route path="/prompt-ideas" element={<RequireAuth><PromptIdeas /></RequireAuth>} />
        <Route path="/account" element={<RequireAuth><Account /></RequireAuth>} />
      </Route>

      {/* AdminShell owns the admin guard for every route below it. */}
      <Route path="/admin" element={<AdminShell />}>
        <Route index element={<AdminOverview />} />
        <Route path="tasks" element={<AdminTasks />} />
        <Route path="tasks/:id" element={<AdminTaskDetail />} />
        <Route path="compute" element={<AdminCompute />} />
        <Route path="policy" element={<AdminPolicy />} />
        <Route path="users" element={<AdminUsers />} />
        <Route path="aliases" element={<AdminAliases />} />
        <Route path="killswitch" element={<AdminKillSwitch />} />
        <Route path="prices" element={<AdminCatalog />} />
      </Route>
    </Routes>
  );
}
